"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var projectActions = require("@caddigital/sok-reducers/lib/actions/project");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var components_1 = require("components");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var Types = require("types");
var translate_1 = require("utils/translate");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        viewportSize: state.viewport.size,
        projectStatuses: state.project.projectStatuses,
        projectTypes: state.project.projectTypes
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchStatuses: function () { return dispatch(projectActions.StatusesActions.fetchRequest()); },
    addStatusItem: function (name) {
        return dispatch(projectActions.StatusesActions.addRequest(name));
    },
    editStatusItem: function (item) {
        return dispatch(projectActions.StatusesActions.editRequest(item));
    },
    removeStatusItem: function (item) {
        return dispatch(projectActions.StatusesActions.removeRequest(item));
    },
    fetchTypes: function () { return dispatch(projectActions.TypesActions.fetchRequest()); },
    addTypeItem: function (name) {
        return dispatch(projectActions.TypesActions.addRequest(name));
    },
    editTypeItem: function (item) {
        return dispatch(projectActions.TypesActions.editRequest(item));
    },
    removeTypeItem: function (item) {
        return dispatch(projectActions.TypesActions.removeRequest(item));
    },
    clear: function () { return (dispatch(projectActions.StatusesActions.clear()),
        dispatch(projectActions.TypesActions.clear())); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchStatuses();
        this.props.fetchTypes();
    },
    componentDidUpdate: function (prev) {
        if (this.props.projectStatuses.status !== prev.projectStatuses.status &&
            this.props.projectStatuses.status === 'STANDBY' &&
            prev.projectStatuses.status !== 'STANDBY') {
            this.props.fetchStatuses();
        }
        if (this.props.projectTypes.status !== prev.projectTypes.status &&
            this.props.projectTypes.status === 'STANDBY' &&
            prev.projectTypes.status !== 'STANDBY') {
            this.props.fetchStatuses();
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var ListComponentEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('addIsOpen', 'setAddIsOpen', false), (0, recompose_1.withState)('editIsOpen', 'setEditIsOpen', null), (0, recompose_1.withState)('removeIsOpen', 'setRemoveIsOpen', null), (0, recompose_1.withState)('addInput', 'setAddInput', ''), recompose_1.pure);
var ListComponent = ListComponentEnhance(function (props) { return (React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)("project/".concat(props.type, "/panel/header")), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-list', prefix: 'fas' }), disableCollapse: true, headerButtons: React.createElement("div", { className: 'header-button' },
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', onClick: function () { return props.setAddIsOpen(true); } }, (0, translation_1.getLocalization)('userfront/button/add'))) },
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.state.removeStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
        (0, translation_1.getLocalization)("project/".concat(props.type, "/remove/fetching")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/remove/fetched")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/remove/failed"))),
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.state.editStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
        (0, translation_1.getLocalization)("project/".concat(props.type, "/edit/fetching")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/edit/fetched")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/edit/failed"))),
    React.createElement(sok_ui_1.RequestStatusBox, { status: props.state.addStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
        (0, translation_1.getLocalization)("project/".concat(props.type, "/add/fetching")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/add/fetched")),
        (0, translation_1.getLocalization)("project/".concat(props.type, "/add/failed"))),
    React.createElement(React.Fragment, null,
        props.state.status === 'FETCHING' && (React.createElement("div", { key: 'fetching', className: 'panel-content-container loading' },
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        props.state.status === 'FAILED' && (React.createElement("div", { key: 'failed', className: 'panel-content-container failed' },
            React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: props.fetch })))),
        props.state.status === 'FETCHED' && (React.createElement("div", { key: 'list', className: 'panel-content-container' },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, (0, translation_1.getLocalization)('admin/misc/project/value')),
                        React.createElement("td", null, (0, translation_1.getLocalization)('admin/misc/project/translation')),
                        React.createElement("td", null),
                        React.createElement("td", null))),
                React.createElement("tbody", null, props.state.list.map(function (x) { return (React.createElement("tr", null,
                    React.createElement("td", null, x.name),
                    React.createElement("td", null, (0, translation_1.getLocalization)("".concat(props.type === 'type' ? 'projectType' : 'projectStatus', "/").concat(x.name))),
                    React.createElement("td", null,
                        React.createElement(components_1.TableRowIcon, { circle: true, title: (0, translation_1.getLocalization)('buttons/edit'), className: 'black', icon: 'fa-pen', onClick: function () {
                                props.setEditIsOpen(__assign({}, x));
                            } })),
                    React.createElement("td", null,
                        React.createElement(components_1.TableRowIcon, { circle: true, title: (0, translation_1.getLocalization)('buttons/delete'), className: 'red', icon: 'fa-times', disabled: x.inUse, onClick: function () {
                                props.setRemoveIsOpen(x);
                            } })))); }))))),
        React.createElement(sok_ui_1.Modal, { isOpen: props.addIsOpen },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.setAddIsOpen(false); } }, (0, translation_1.getLocalization)("project/".concat(props.type, "/modal/add"))),
            React.createElement(sok_ui_1.Container, null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("global/name"),
                    ":"),
                React.createElement(sok_ui_1.TextInput, { value: props.addInput, onChange: function (e) { return props.setAddInput(e.target.value); } })),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.addInput.length === 0, onClick: function () {
                        props.addItem(props.addInput);
                        props.setAddInput('');
                        props.setAddIsOpen(false);
                    } }, (0, translation_1.getLocalization)("userfront/button/add")),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.setAddIsOpen(false); } }, (0, translation_1.getLocalization)("buttons/close")))),
        React.createElement(sok_ui_1.Modal, { isOpen: props.editIsOpen !== null },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.setEditIsOpen(null); } }, (0, translation_1.getLocalization)("project/".concat(props.type, "/modal/edit"))),
            React.createElement(sok_ui_1.Container, null,
                React.createElement("label", null,
                    (0, translation_1.getLocalization)("global/name"),
                    ":"),
                React.createElement(sok_ui_1.TextInput, { value: props.editIsOpen ? props.editIsOpen.name : '', onChange: function (e) {
                        return props.editIsOpen &&
                            props.setEditIsOpen(__assign(__assign({}, props.editIsOpen), { name: e.target.value }));
                    } })),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { color: 'green', disabled: (props.editIsOpen ? props.editIsOpen.name : '').length === 0, onClick: function () {
                        props.editIsOpen && props.editItem(props.editIsOpen);
                        props.setEditIsOpen(null);
                    } }, (0, translation_1.getLocalization)('buttons/edit')),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.setEditIsOpen(null); } }, (0, translation_1.getLocalization)("buttons/close")))),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeIsOpen !== null, close: function () { return props.setRemoveIsOpen(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null,
                            "Project ",
                            props.type,
                            ":",
                            ' ',
                            props.removeIsOpen && props.removeIsOpen.name)))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                        props.removeIsOpen && props.removeItem(props.removeIsOpen);
                        props.setRemoveIsOpen(null);
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setRemoveIsOpen(null); } })) })))); });
exports.default = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(sok_ui_1.BoxLayout, { key: 'statuses', className: 'project-statuses-and-types', direction: props.viewportSize === 'DESKTOP' ? 'row' : 'column' },
        React.createElement(ListComponent, { type: 'status', state: props.projectStatuses, addItem: props.addStatusItem, editItem: props.editStatusItem, removeItem: props.removeStatusItem, fetch: props.fetchStatuses }),
        React.createElement(ListComponent, { type: 'type', state: props.projectTypes, addItem: props.addTypeItem, editItem: props.editTypeItem, removeItem: props.removeTypeItem, fetch: props.fetchTypes })))); });
